import React from "react";
import styled from "styled-components";
import { FaChevronLeft } from "react-icons/fa";

import { H2, Body3, InternalLink } from "../Typography/index";
import { CrossBrowserGradient } from "../../design/mixins";
import theme from "../../design/theme";

const SIDE_NAV_WIDTH = "12vw";

export const Container = styled.div`
  min-height: 100vh;
  padding-left: calc(${SIDE_NAV_WIDTH} + ${({ theme }) => theme.xxl}px);
  background: ${({ theme }) => theme.neutrals.lightGrey};
  padding-bottom: ${({ theme }) => theme.lg}px;

  @media screen and (max-width: ${({ theme }) => theme.tablet}px) {
    padding-left: unset;
  }
`;

export const LoaderContainer = styled.div`
  width: 100%;
  min-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BANNER_PADDING_WIDE = "0 10%";
const BANNER_PADDING_NARROW = "0 5%";

export const Banner = styled.div`
  height: 280px;
  ${CrossBrowserGradient};
  padding: ${BANNER_PADDING_WIDE};
  overflow-y: visible;
  display: flex;
  align-items: center;
  padding-top: 80px;

  @media screen and (max-width: ${({ theme }) => theme.tablet}px) {
    height: 240px;
    padding: ${BANNER_PADDING_NARROW};
  }
`;

const CONTENT_OFFSET = {
  web: 100,
  mob: 56,
};

export const BannerTitleSection = styled.div`
  padding: ${({ theme }) => theme.md}px;
  margin-top: -${CONTENT_OFFSET.web - "24"}px;

  @media screen and (max-width: ${({ theme }) => theme.tablet}px) {
    margin-top: -${CONTENT_OFFSET.mob - "24"}px;
  }
`;

export const ProfileSkeleton = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  flex: 1;
`;

export const BackIcon = styled(FaChevronLeft)`
  font-size: ${({ theme }) => theme.copy3.fontSize};
  color: ${({ theme }) => theme.neutrals.white};
  margin-right: 6px;
  cursor: pointer;
`;

export const Avatar = styled.img`
  height: 32px;
  width: 32px;
  margin-right: ${({ theme }) => theme.sm}px;
`;

export const NameWrapper = styled.div`
  flex-direction: column;
  display: flex;
  height: 100%;
`;

export const SectionContent = styled.div`
  padding: ${({ theme }) => `${1.5 * theme.xxl}px ${2 * theme.xxl}px`};
  margin: ${BANNER_PADDING_WIDE};
  margin-top: -${CONTENT_OFFSET.web}px;
  border-radius: ${({ theme }) => theme.xl}px;
  min-height: 250px;
  background: ${({ theme }) => theme.neutrals.white};
  position: relative;
  -webkit-box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.08);
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.08);

  @media screen and (max-width: ${({ theme }) => theme.tablet}px) {
    padding: ${({ theme }) => `${theme.xl}px ${2 * theme.lg}px`};
    margin: ${BANNER_PADDING_NARROW};
    margin-top: -${CONTENT_OFFSET.mob}px;
  }
`;

export const SideNav = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  overflow: visible;
  height: 100%;
  width: ${SIDE_NAV_WIDTH};
  background: ${({ theme }) => theme.neutrals.white};
  padding: ${({ theme }) => `160px ${theme.lg}px ${theme.lg}px}`};
  -webkit-box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.08);
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.08);

  ${InternalLink} {
    text-decoration: none;

    ${Body3} {
      font-weight: 500;
      cursor: pointer;
      line-height: 1.5;
      color: ${({ theme }) => theme.neutrals.black};
      text-align: left;
      margin: ${({ theme }) => `${theme.xl}px 0 ${theme.xl}px ${theme.sm}px`};
    }

    &.active {
      &:after {
        height: 40px;
        width: 40px;
        background: red;
        display: block;
      }

      ${Body3} {
        font-weight: 600;
        text-decoration: underline;
        text-decoration-thickness: 3px;
        text-decoration-color: ${({ theme }) => theme.neutrals.black};
        text-underline-offset: 4px;
      }

      ${Body3}:after {
        height: 20px;
        width: 20px;
        background: red;
      }
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.tablet}px) {
    width: 100vw;
    height: unset;
    position: static;
  }
`;

export const Bar = styled.div`
  position: absolute;
  top: 150px;
  right: 0px;
  width: 2.5px;
  border-radius: 1px;
  height: 28px;
  background: ${({ theme }) => theme.neutrals.black};
`;

export const AccountSectionHeader = styled(H2)`
  text-align: left;

  @media screen and (max-width: ${({ theme }) => theme.tablet}px) {
    font-size: ${({ theme }) => theme.copy3.fontSize};
  }
`;

export const AccountSectionNotFound = () => (
  <SectionContent>
    <AccountSectionHeader>404 Error</AccountSectionHeader>
    <br />
    <Body3 textAlign="left" padding={`${theme.xs}px 0 0 0`}>
      Looks like the content you requested does not exist.
    </Body3>
  </SectionContent>
);
